import React, { Component } from "react"
import { connect } from "react-redux"
import { Card } from "react-bootstrap"
import { Link } from "react-router-dom/cjs/react-router-dom"
import { FormattedMessage } from "react-intl"
import CountryForm from "../../components/forms/CountryForm"
import MaterialIcon from "../../components/elements/MaterialIcon"

class CountryCreatePage extends Component {
	render() {
		return (
			<div className="clients-create-page private-page">
				<div className="top-actions-row">
					<Link to="/countries" className="btn-primary btn-roundet btn-dropshadow btn btn-sm"><MaterialIcon icon="arrow_back" /> <FormattedMessage id="buttons.back_to_country" /> </Link>
				</div>
				<Card className="clients-card fadeInLoadUp">
					<Card.Body>
						<CountryForm />
					</Card.Body>
				</Card>
			</div>
		)
	}
}

CountryCreatePage.propTypes = {
}

const mapStateToProps = (state) => ({})

export default connect(mapStateToProps, {})(CountryCreatePage)
